module.exports = __webpack_public_path__ + "static/img/wzry-companyProducts1.e0c95627.png";